import {createLogger} from 'shared/services/logger';

const logger = createLogger('slide-tray:us-extension:MarkAsRead');

export function MarkAsRead (uScope, viewport, dstWrapper) {
  if (!dstWrapper.canStart()) {
    logger.warn('DST extension "Mark as Read" cannot start because the DST is disabled.');
    return;
  }
  if (window.SystemParms && (window.SystemParms.DisableAutoSlideFlip === '1' || window.SystemParms.DSTSetAutoReadSlides === '0')) {
    logger.warn('DST extension "Mark as Read" cannot start because it is disabled by SystemParm');
    return;
  }

  const dst = dstWrapper.getInstance();

  // Used to prevent mark as red from triggering when pinning or resizing
  let isSuspended = false;

  const listeners = [
    uScope.events.on('uScope:before-resize', () => {
      isSuspended = true;
    }),

    uScope.events.on('uScope:after-resize', () => {
      isSuspended = false;
    }),

    viewport.events.on('viewport:state-changed', () => {
      if (isSuspended) {
        return;
      }
      let imageId = viewport.getImageId();
      // DST does not expect an @ sign
      imageId = imageId.replace('@', '');
      dst.toggleRead(imageId, true);
      listeners.forEach(unsubscribe => unsubscribe());
    })
  ];
}



// WEBPACK FOOTER //
// ./src/slide-tray/uScope-extensions/mark-as-read/MarkAsRead.js